import React from "react";
import PrettyDate from "./PrettyDate";
import DirectionType from "./DirectionType";
import {validityPeriodToDisplay} from "../../common/displayUtils";
import {LIGHT_TEXT_COLOR, colorForDirection} from "../../common/styles";


const recommendationStyle = {
    padding: "20px",
    margin: 0,
    boxShadow: "0 0 20px rgba(0,0,0,0.2)",
    borderTop: "1px solid rgba(0,0,0,0.15)",
    borderBottom: "1px solid rgba(0,0,0,0.15)"
};

const Recommendation = (props) => {
    const targetPrice = (props.targetPrice !== null)
        ? <div>
            <span style={{ color: LIGHT_TEXT_COLOR }}>Target Price:</span>
            <span className="x-target-price">{props.targetPrice}</span>
          </div>
        : undefined;

    const validityPeriod = (props.validityPeriod !== null)
        ? <div>
            <span style={{ color: LIGHT_TEXT_COLOR }}>Validity Period:</span>
            <span className="x-validity-period">{validityPeriodToDisplay(props.validityPeriod)}</span>
          </div>
        : undefined;

    const productionDate = props.producedOn
        ? <div><span style={{ color: LIGHT_TEXT_COLOR }}>Production date:</span> <span className="x-produced-on"><PrettyDate date={props.producedOn} timeOnSameLine={true} /></span></div>
        : undefined;

    return (
        <div style={recommendationStyle} className="x-this-recommendation">
            <table>
                <tbody>
                    <tr>
                        <td className="x-disseminated-on" style={{verticalAlign: "top", padding: "10px", width: "120px"}}>
                            <PrettyDate date={props.disseminatedOn} />
                        </td>
                        <td style={{verticalAlign: "top", padding: "10px"}}>
                            <div style={{marginBottom: 10}}>
                                <span className="x-author-name">{props.authorName}</span> recommends:
                            </div>
                            <div className="x-issuer" style={{}}>{props.companyName}</div>
                            <h2 style={{fontSize: "150%", margin: 0}}>
                                <DirectionType style={{display: "inline-block"}} direction={props.direction}/>
                                <span> </span>
                                <span className="x-isin">{props.isin}</span>
                            </h2>
                            <div className="x-derivative-description" style={{marginBottom: "10px"}}>{props.derivativeDescription}</div>
                            <div style={{marginBottom: "3px"}}>{targetPrice}</div>
                            <div>{validityPeriod}</div>
                            {productionDate}
                            <div>
                              <span style={{ color: LIGHT_TEXT_COLOR }}>First disseminated: </span>
                              <PrettyDate className="x-first-disseminated-on" date={props.firstDisseminatedOn} timeOnSameLine={true} />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
Recommendation.propTypes = {
    authorName: React.PropTypes.string,
    disseminatedOn: React.PropTypes.string,
    producedOn: React.PropTypes.string,
    isin: React.PropTypes.string,
    direction: React.PropTypes.string,
    derivativeDescription: React.PropTypes.string,
    issuer: React.PropTypes.string,
    targetPrice: React.PropTypes.string,
    validityPeriod: React.PropTypes.string,
    companyName: React.PropTypes.string
};
Recommendation.defaultProps = {
    direction:  null,
    derivativeDescription: null,
    companyName: null
};

export default Recommendation;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/components/Recommendation.js
 **/